import React, { useState } from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { faEyeSlash as privateIcon } from '@fortawesome/pro-regular-svg-icons';

import Commission from './commission';
import DeleteModal from './delete_modal';

import './styles.scss';

export default function Broker({
  children,
  commission,
  deletable,
  disableCommisionView,
  icon,
  index,
  justify = true,
  transactionSide,
}) {
  const [deleting, setDeleting] = useState();

  // TODO: Consolidate broker/contact styling
  return (
    <div className={classNames('broker d-flex flex-1', { justify })}>
      {icon}
      {children}
      {disableCommisionView ? (<div className="commission d-flex align-items-center">
        <span className="text-muted">
          <span className="mr-2">Private</span>
          <FontAwesomeIcon icon={privateIcon} />
        </span>
      </div>) : (<>
        <Commission commission={commission} index={index} transactionSide={transactionSide} />

        {deletable &&
          <FontAwesomeIcon
            className="clickable"
            icon={faTrashAlt}
            name="delete-control"
            onClick={() => setDeleting(true)}
          />
        }

        <DeleteModal
          commission={deleting ? commission : null}
          label="broker"
          onClose={() => setDeleting(false)}
        />
      </>)}

    </div>
  );
}

Broker.propTypes = {
  children: PropTypes.node,
  commission: PropTypes.object.isRequired,
  deletable: PropTypes.bool,
  disableCommisionView: PropTypes.bool,
  icon: PropTypes.node,
  index: PropTypes.number,
  justify: PropTypes.bool,
  transactionSide: PropTypes.string,
};
